<div class="content">
    <div class="row items-push">
        <div class="col-sm-12 text-left">
            <ol class="breadcrumb push-10-t">
                <li><a [routerLink]="['/']">Inicio</a></li>
                <li><a class="link-effect" [routerLink]="['/hipos']"
                  >HIPOS</a></li>
                <li><span class="link-effect">Registrar</span></li>
            </ol>
        </div>
    </div>
  </div>

  <div class="content">
    <div class="block">
        <div class="block-header">
            <h3 class="block-title">Registro HIPOS</h3>
        </div>
        <form #modelForm="ngForm" (ngSubmit)="onSubmit(modelForm)" appIdentityRevealed>
        <div class="block-content">
            <div class="form-horizontal">
              <div class="form-group">
                <label class="col-md-2 control-label">Compañía (*):</label>
                <div class="col-md-4">
                  <mat-form-field appearance="outline">
                    <mat-label> Seleccione: </mat-label>
                    <mat-select matSelect [(ngModel)]="model.idCompaniaSelected"
                    name="idCompaniaSelected"
                    #idCompaniaSelected="ngModel"
                    (selectionChange)="companiaChanged()" 
                    required>
                      <mat-option *ngFor="let company of listaCompanias" [value]="company.idCompania">
                        {{ company.nombre }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                <label class="col-md-2 control-label">Sede (*):</label>
                <div class="col-md-4">
                  <mat-form-field appearance="outline" hideRequiredMarker>
                    <mat-label>Sede</mat-label>
                    <mat-select
                      matSelect
                      [(ngModel)]="model.idSedeSelected"
                      name="idSedeSelected"
                      #idSedeSelected="ngModel" 
                      (selectionChange)="sedeChanged()" 
                      required
                    >
                    <!-- <mat-option [value]="0">Seleccione</mat-option> -->
                      <mat-option
                        *ngFor="let item of listaSedes; index as i"
                        [value]="item.idSede"
                        >{{ item.nombre }}</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>  
          
              </div>
                <div class="form-group">
                    <label class="col-md-2 control-label">Empresa (*):</label>
                    <div class="col-md-4">
                      <mat-form-field appearance="outline" hideRequiredMarker>
                        <mat-label>Empresa</mat-label>
                        <mat-select [formControl]="bankServerSideCtrl" placeholder="Empresa" [(ngModel)]="model.idContratista" required>
                          <!-- place ngx-mat-select-search inside mat-option to allow opening without initial selection -->
                          <mat-option>
                            <ngx-mat-select-search [formControl]="bankServerSideFilteringCtrl" [searching]="searching" 
                              placeholderLabel="Empresa" 
                              noEntriesFoundLabel="No se encontraron coincidencias"
                            ></ngx-mat-select-search>
                          </mat-option>
                          <mat-option *ngFor="let bank of filteredServerSideBanks | async" [value]="bank.idContratista">
                            {{bank.nombre}}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>                
                    </div>
                </div>   
                <div class="form-group">
                  <label class="col-md-2 control-label">GBU (*):</label>
                  <div class="col-md-4">
                    <mat-form-field appearance="outline">
                        <mat-label>
                          Seleccione
                        </mat-label>
                        <mat-select matSelect
                        [(ngModel)]="model.idGbuSelected"
                        name="idGbuSelected"
                        #idGbuSelected="ngModel" 
                        required>
                          <mat-option
                            *ngFor="let item of listaGbus; index as i"
                            [value]="item.idGbu"
                            >{{ item.nombre }}</mat-option>
                        </mat-select>
                      </mat-form-field>             
                  </div>   
                  <label class="col-md-2 control-label">Proyecto:</label>
                  <div class="col-md-4">
                    <mat-form-field appearance="outline">
                        <mat-label>
                          Proyecto
                        </mat-label>
                        <mat-select matSelect
                        [(ngModel)]="model.idProyecto"
                        name="idProyecto"
                        #idProyecto="ngModel" >
                          <mat-option
                            *ngFor="let item of listaProyectos; index as i"
                            [value]="item.idProyecto"
                            >{{ item.nombre }}</mat-option>
                        </mat-select> 
                      </mat-form-field>             
                  </div>            
              </div>
              <div class="form-group">
                <label class="col-md-2 control-label">Categoría (*):</label>
                <div class="col-md-4">
                  <mat-form-field appearance="outline">
                      <mat-label>
                        Seleccione
                      </mat-label>
                      <mat-select matSelect
                      [(ngModel)]="model.idCategoriaHipoSelected"
                      name="idCategoriaHipoSelected"
                      #idCategoriaHipoSelected="ngModel"
                      required>
                        <mat-option
                            *ngFor="let item of listaCategorias; index as i"
                            [value]="item.idCategoriaHipo"
                            >{{ item.nombre }}</mat-option>
                      </mat-select>
                    </mat-form-field>             
                </div>   
                <label class="col-md-2 control-label">Fecha Evento (*):</label>
                <div class="col-md-4">
                  <mat-form-field appearance="outline">
                    <mat-label>Fecha Evento</mat-label>
                    <input
                      matInput
                      [matDatepicker]="pckrFechaEvento"
                      [(ngModel)]="model.fechaEvento"
                      id="fechaEvento"
                      name="fechaEvento"
                      required
                    />
                    <mat-datepicker-toggle
                      matSuffix
                      [for]="pckrFechaEvento"
                    ></mat-datepicker-toggle>
                    <mat-datepicker #pckrFechaEvento></mat-datepicker>
                    </mat-form-field>             
                </div>            
            </div>
            <div class="form-group">
              <label class="col-md-2 control-label">Texto Identificativo (*):</label>
              <div class="col-md-10">
                <mat-form-field appearance="outline">
                  <mat-label>Texto Identificativo</mat-label>
                  <input matInput type="text" placeholder="Texto Identificativo" maxlength="250"
                    name="TextoIdentificativo" [(ngModel)]="model.textoIdentificativo" required
                  >
                  </mat-form-field>             
              </div>               
          </div>
              <div class="form-group">
                <label class="col-md-2 control-label">Descripción:</label>
                <div class="col-md-10">
                  <mat-form-field class="example-full-width" appearance="outline">
                    <mat-label>Descripción</mat-label>
                    <textarea
                      matInput
                      placeholder="Motivo"
                      rows="5"
                      [(ngModel)]="model.descripcion"                      
                      name="comentarios" maxlength="2000"
                    ></textarea>
                    <!-- 
                      [disabled]="modelPersona.idEstado === 2" -->
                  </mat-form-field>
                </div>
              </div> 
              <div class="form-group">
                  
                <label class="col-md-2 control-label">Regla Incumplida (*):</label>
                <div class="col-md-10">
                  <mat-form-field appearance="outline">
                      <mat-label>
                        Seleccione
                      </mat-label>
                      <mat-select matSelect
                      [(ngModel)]="model.idTipoReglaSelected"
                      name="idTipoReglaSelected"
                      #idTipoReglaSelected="ngModel" required>
                        <mat-option
                            *ngFor="let item of listaTipoRegla; index as i"
                            [value]="item.idTipoRegla"
                            >{{ item.nombre }}</mat-option>
                      </mat-select>
                    </mat-form-field>             
                </div>            
            </div>
            <div class="form-group">  
              <label class="col-md-2 control-label">Tipo Accidente:</label>
              <div class="col-md-4">
                <mat-form-field appearance="outline">
                  <mat-label>
                    Seleccione
                  </mat-label>
                  <mat-select matSelect
                  [(ngModel)]="model.idTipoAccidenteSelected"
                  name="idTipoAccidenteSelected"
                  #idTipoReglaSelected="ngModel" required>
                    <mat-option
                        *ngFor="let item of listaTipoAccidente; index as i"
                        [value]="item.idTipoAccidente"
                        >{{ item.nombre }}</mat-option>
                  </mat-select>
                </mat-form-field>               
              </div>
                <label class="col-md-2 control-label">Tiempo Perdido (*):</label>
                <div class="col-md-1">
                  <mat-form-field appearance="outline">
                      <mat-label>
                        Seleccione
                      </mat-label>
                      <mat-select matSelect
                      [(ngModel)]="model.tiempoPerdidoSelected" 
                      name="tiempoPerdidoSelected"
                      #tiempoPerdidoSelected="ngModel" required>
                      <mat-option
                      *ngFor="let item of optionsSINO; index as i"
                      [value]="item.id"
                      >{{ item.nombre }}</mat-option>
                      </mat-select>
                    </mat-form-field>             
                </div>  
              <label class="col-md-1 control-label" *ngIf="model.tiempoPerdidoSelected == 1"># Días:</label>
              <div class="col-md-1" *ngIf="model.tiempoPerdidoSelected == 1">
                <mat-form-field appearance="outline">
                  <mat-label>Días</mat-label>
                  <input matInput type="text" placeholder="# Días Perdidos" maxlength="4"
                    name="nroDiasPerdidos" [(ngModel)]="model.nroDiasPerdidos" appTwoDigitDecimaNumber
                  >
                  </mat-form-field>             
              </div>           
          </div>
          <div class="form-group">
            <label class="col-md-2 control-label">Tipo Empleado (*):</label>
            <div class="col-md-4">
              <mat-form-field appearance="outline">
                  <mat-label>
                    Seleccione
                  </mat-label>
                  <mat-select matSelect
                  [(ngModel)]="model.idTipoEmpleadoSelected"
                  name="idTipoEmpleadoSelected"
                  #idTipoEmpleadoSelected="ngModel" required>
                    <mat-option
                            *ngFor="let item of listaTipoEmpleado; index as i"
                            [value]="item.idTipoEmpleado"
                            >{{ item.nombre }}</mat-option>
                  </mat-select>
                </mat-form-field>             
            </div>  
            <label class="col-md-2 control-label">Acto o Condición (*):</label>
            <div class="col-md-4">
              <mat-form-field appearance="outline">
                  <mat-label>
                    Seleccione
                  </mat-label>
                  <mat-select matSelect
                  [(ngModel)]="model.idActoCondicionSelected"
                  name="idActoCondicionSelected"
                  #idActoCondicionSelected="ngModel" required>
                    <mat-option
                            *ngFor="let item of listaActoCondicion; index as i"
                            [value]="item.idActoCondicion"
                            >{{ item.nombre }}</mat-option>
                  </mat-select>
                </mat-form-field>             
            </div>             
        </div>
        <div class="form-group"> 
          <label class="col-md-2 control-label">Enlace Repositorio:</label>
          <div class="col-md-4">
            <mat-form-field appearance="outline">
                <mat-label>
                  Seleccione
                </mat-label>
                <input matInput type="text" placeholder="Enlace Repositorio" maxlength="500"
                    name="enlaceRepositorio" [(ngModel)]="model.enlaceRepositorio" >
              </mat-form-field>             
          </div>    
      </div>
            </div>
        </div>
        <div class="block-content">
            <div class="form-horizontal">
                <mat-divider class="engie-divider"></mat-divider>
            </div>
            <mat-tab-group >
                <mat-tab label="Seguimiento Acciones">
                  <div class="form-horizontal">
                    <div class="form-group">
                      <div class="col-sm-12 text-right">
                        <button type="button" class="btn btn-new" mat-raised-button (click)="openDialogAccion()" ><mat-icon>description</mat-icon> Agregar Acción</button>
                        
                      </div>
                    </div>
                  </div>
                    <div class="table-responsive">
                        <table mat-table [dataSource]="model.acciones" class="table table-striped table-vcenter">
                          <ng-container matColumnDef="detalle">
                            <th mat-header-cell *matHeaderCellDef>Detalle</th>
                            <td mat-cell *matCellDef="let element">{{ element.detalle }}</td>
                          </ng-container>
                    
                          <ng-container matColumnDef="fechalimite">
                            <th mat-header-cell *matHeaderCellDef>Fecha Límite</th>                            
                            <td mat-cell *matCellDef="let element" class="centre">{{ element.fechaLimite | date:'dd/MM/yyyy' }}</td>
                          </ng-container>

                          <ng-container matColumnDef="fecharealcierre">
                            <th mat-header-cell *matHeaderCellDef>Fecha Cierre Real</th>                            
                            <td mat-cell *matCellDef="let element" class="centre">{{ element.fechaCierre | date:'dd/MM/yyyy' }}</td>
                          </ng-container>

                          <ng-container matColumnDef="estado">
                            <th mat-header-cell *matHeaderCellDef>Estado</th>                            
                            <td mat-cell *matCellDef="let element" class="centre">{{ element.estado }}</td>
                          </ng-container>
        
                    
                          <ng-container matColumnDef="acciones">
                            <th mat-header-cell *matHeaderCellDef>Acciones</th>
                            <td mat-cell *matCellDef="let element"> 
                              <button type="button" mat-icon-button color="primary" (click)="openDialogAccion(element)" aria-label="Editar">
                                <mat-icon>create</mat-icon>
                              </button>
                              <button type="button" mat-icon-button color="primary" (click)="eliminarAccion(element)" aria-label="Eliminar">
                                <mat-icon>delete</mat-icon>
                              </button>
                            </td>
                          </ng-container>
                    
                          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
                        </table>
            
                      </div>  
                </mat-tab>
            </mat-tab-group>
        </div>
        <div class="block-content">
          <div class="form-horizontal pad-25">
              <div class="form-group">
                  <div class="col-sm-12 text-right">
  
                    <button type="submit" class="btn btn-naranja" mat-raised-button><mat-icon>save</mat-icon> Guardar</button>
                    <a class="btn btn-naranja2" mat-raised-button (click)="closed()" ><mat-icon>exit_to_app</mat-icon> Salir</a>
                  </div>
              </div>
          </div>
        </div>
      </form>
    </div>
  </div>